module.exports = "/dist/assets/on_logo.svg";